import { render, staticRenderFns } from "./remit.vue?vue&type=template&id=2c81d5f5&scoped=true"
import script from "./remit.vue?vue&type=script&lang=js"
export * from "./remit.vue?vue&type=script&lang=js"
import style0 from "./remit.vue?vue&type=style&index=0&id=2c81d5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81d5f5",
  null
  
)

export default component.exports